import { render, staticRenderFns } from "./FollowUps.vue?vue&type=template&id=a2942406"
import script from "./FollowUps.vue?vue&type=script&lang=js"
export * from "./FollowUps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports